
const data = [
    {
      id: 1,
      desc: "",
      name: "Samsung Galaxy M32",
      rating: "⭐⭐⭐⭐ 4.5",
      img: "https://rukminim2.flixcart.com/image/312/312/kt4ozgw0/mobile/f/d/s/m32-sm-m326b-sm-m326b-ds-samsung-original-imag6jmvqyef5nyf.jpeg?q=70",
      isDisabled: false,
      price: 14499
    },
    {
      id: 2,
      desc: "",
      name: "Samsung Galaxy M12",
      img: "https://rukminim2.flixcart.com/image/312/312/kmjhw280/mobile/h/k/v/galaxy-m12-galaxy-m12-samsung-original-imagffy3wzrmy7ep.jpeg?q=70",
      isDisabled: false,
      price: 9999
    },
    {
      id: 3,
      desc: "",
      name: "Vivo Y73",
      rating: "⭐⭐⭐⭐ 4.1",
      img: "https://m.media-amazon.com/images/I/51emzGhS57S._AC_UL320_.jpg",
      isDisabled: false,
      price: 19990
    },
    {
      id: 4,
      desc: "",
      name: "OPPO A31",
      price: 11990,
      rating: "⭐⭐⭐⭐ 4.2",
      img: "https://m.media-amazon.com/images/I/71KCwNV6MuL._AC_UL320_.jpg",
      isSelected: false,
    },
    {
      id: 5,
      desc: "",
      name: "Redmi Note 11",
      price: 9999,
      rating: "⭐⭐⭐⭐ 4.3",
      img: "https://rukminim2.flixcart.com/image/312/312/l19m93k0/mobile/o/l/f/note-11-pro-5g-21091116i-redmi-original-imagcvg4ghr3ykge.jpeg?q=70",
      isSelected: false,
    },
    {
      id: 6,
      desc: "",
      name: "Xiaomi 12 Pro",
      price: 62999,
      img: "https://rukminim2.flixcart.com/image/312/312/jpcxrww0/mobile/x/b/b/mi-redmi-6-pro-na-original-imafawhpysnx884c.jpeg?q=70",
      isSelected: false,
    },
    {
      id: 7,
      desc: "",
      name: "Redmi 10",
      price: 13495,
      rating: "⭐⭐⭐⭐ 4.1",
      img: "https://m.media-amazon.com/images/I/31jOF0g5tVL._AC_UL320_.jpg",
      isSelected: false,
    },
    {
      id: 8,
      desc: "",
      name: "OPPO A76",
      price: 17499,
      img: "https://m.media-amazon.com/images/I/31QnVF2gn5L._AC_UL320_.jpg",
      isSelected: false,
    },
  ];
  

  export default data;